import { StoreState } from "store/rootReducer";

export const paypalSubscriptionSelector = (store: StoreState) => store.paypal?.subscription;
export const paypalFreeTrialUsedSelector = (store: StoreState) => store.paypal?.freeTrialUsed;
